import { YYYY_MM_DD_HH_mm_ss } from '@beable/mwm-commons-date-time';
import { APIError } from '@beable/mwm-commons-endpoint-client';
import {
  GetSitePauseDatesResponse,
  RosterBackendClient,
} from '@beable/roster-backend-client-v1';
import { InternalAxiosRequestConfig } from 'axios';
import { Result } from 'true-myth';

export const defaultTimeout = 20000;

function getRosterBackendUrl(): string {
  const rosterBackendUrl: string | undefined =
    process.env['REACT_APP_BACKEND_BASE_URL'];

  if (rosterBackendUrl === undefined) {
    throw new Error(
      `REACT_APP_BACKEND_BASE_URL environment variable missing.`,
    );
  }

  return rosterBackendUrl;
}

class RosterBackendService extends RosterBackendClient {
  constructor(rosterBackendUrl: string) {
    super(rosterBackendUrl, {
      timeout: defaultTimeout,
      withCredentials: true,
    });
    if (process.env.NODE_ENV === 'test') {
      this.client.interceptors.request.use(function (config: InternalAxiosRequestConfig) {
        console.log(`** Call being made to this url. It should probably be mocked: ${config.url}`);
        return config;
      });
    }
  }

  responseHandler(result: any, errorMsg: string) {
    if (result.isOk()) {
      const response = result.unwrapOr(undefined);
      return response;
    }
    result.unwrapOrElse((error: any) => {
      throw new Error(`${errorMsg} ${error.message}`);
    });
  }

  async getSitePauseDatesWithParse(siteId: number): Promise<Result<GetSitePauseDatesResponse, APIError<string>>> {
    const response = await this.getSitePauseDates(siteId);
    
    if (response.isOk()) {
      if (response.value.pauseDates !== undefined) {
        response.value.pauseDates = response.value.pauseDates.map(item => ({
          startDate: new YYYY_MM_DD_HH_mm_ss(item.startDate),
          endDate: new YYYY_MM_DD_HH_mm_ss(item.endDate),
          active: item.active,
        }))
      }
      return Result.ok(response.value);
    } else {
      return Result.err(response.error);
    }
  }
}

export default new RosterBackendService(getRosterBackendUrl());
